import React, { useState, useEffect } from 'react'
import { classNames, firstOrSelf } from 'core/helpers/misc'
import { Link } from 'core/components/route'
import { usePrevious } from 'core/hooks/previous'

export const SingleMenuItem = ({ page, actualPage, basename }) => (
	<li
		className={classNames('kt-menu__item', {
			'kt-menu__item--active': !!actualPage && actualPage.href === page.href,
		})}
	>
		<Link className="kt-menu__link" to={basename + firstOrSelf(page.href)}>
			<i className={classNames(page.icon, 'kt-menu__link-icon')} />
			<span className="kt-menu__link-text">{page.title}</span>
		</Link>
	</li>
)

export const DropdownMenuItem = ({ page, actualPage, updateScroll, basename }) => {
	const isActive = page.pages.some(p => !!actualPage && actualPage.href === p.href)
	const wasActive = usePrevious(isActive)
	const [opened, setOpened] = useState(isActive)

	useEffect(() => {
		if (wasActive && !isActive) {
			setOpened(false)
		}
		// eslint-disable-next-line
	}, [isActive])

	useEffect(() => {
		updateScroll()
		// eslint-disable-next-line
	}, [opened])

	return (
		<li
			aria-haspopup="true"
			className={classNames('kt-menu__item kt-menu__item--submenu', {
				'kt-menu__item--open': opened,
			})}
		>
			<button
				className="kt-menu__link kt-menu__toggle"
				onClick={ev => {
					ev.preventDefault()
					setOpened(prev => !prev)
				}}
				type="button"
			>
				<i className={classNames(page.icon, 'kt-menu__link-icon')} />
				<span className="kt-menu__link-text">{page.title}</span>
				<i className="kt-menu__ver-arrow fas fa-angle-right" />
			</button>
			<div className="kt-menu__submenu">
				<ul className="kt-menu__subnav">
					{page.pages.map(p => (
						<li
							aria-haspopup="true"
							className={classNames('kt-menu__item', {
								'kt-menu__item--active': !!actualPage && actualPage.href === p.href,
							})}
							key={firstOrSelf(p.href)}
						>
							<Link className="kt-menu__link" to={basename + firstOrSelf(p.href)}>
								<i className="kt-menu__link-bullet kt-menu__link-bullet--dot">
									<span />
								</i>
								<span className="kt-menu__link-text">{p.title}</span>
							</Link>
						</li>
					))}
				</ul>
			</div>
		</li>
	)
}
